import Vue from 'vue';
import Meta from 'vue-meta'
import Router from 'vue-router';
// import Page from '../views/Page';
import Post from '../views/Post';
import Page404 from '../views/Page404';

Vue.use(Router);
Vue.use(Meta);

const routes = wp.routes.map( e => {

    const { type, id, name, slug, link, template } = e;

    // Regex check for the homepage on local dev env
    const isHomepage = new RegExp(`^http[s]*:\\/\\/${slug}\\/`, "i").test(link);
    const path = isHomepage && "/" || `*${slug}\/`;

    let component = Page404;
    if (type === 'page' && template != null) {
        component = getComponent(template);
    } else if (type === 'post') {
        component = Post;
    }

    return {
        path,
        name: `name-${id}`,
        props: { id, type },
        component
    };

});

routes.push({
    path: "*",
    name: "404",
    component: Page404,
});

export default new Router({
    mode: 'history',
    routes
});

// Dynamically import view component based on Template Slug
function getComponent(template) {
    // TODO better way to do this with regex?
    let component = template.replace('templates/template-','').replace('.php','');
    component = component.charAt(0).toUpperCase() + component.slice(1);

    return () => import(/* webpackChunkName: "[request]" */ `../views/${component}`);
}